<template>
  <div>
    <table class="table" style="font-size: 14px">
      <thead>
        <tr class="table-search">
          <td colspan="6" style="padding-top: 0; padding-left: 0px">
            <b-form-input v-model="search.name" class="search" placeholder="Tegund fjarvista" ref="focusInput" />
          </td>
          <td colspan="3" style="max-width: 80px">
            <div class="float-right" style="margin-top: -10px">
              <CustomButton type="create" title="Ný tegund" v-if="canEdit" @click.native="openSlidebar()" />
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <LinkOrder title="Tegund fjarvista" :filteredList="getList" :list="list" column="heiti" />
          </th>
          <th>
            <LinkOrder title="Kóði" :filteredList="getList" :list="list" column="kodi" />
          </th>
          <th>
            <LinkOrder title="Fjarvistarmargfeldi" :filteredList="getList" :list="list" column="fjarvistar_margf" />
          </th>
          <th>
            <LinkOrder title="Röð" :filteredList="getList" :list="list" column="rod" />
          </th>
          <th>
            <LinkOrder title="Virk" :filteredList="getList" :list="list" column="virk" />
          </th>
          <th>
            <LinkOrder title="Má kennari skrá" :filteredList="getList" :list="list" column="ma_kennari_skra" />
          </th>
          <th>
            <LinkOrder title="Telst sem tími" :filteredList="getList" :list="list" column="telst_sem_timi" />
          </th>
          <th>
            <LinkOrder title="Samr.teg fjarvista" :filteredList="getList" :list="list" column="samr_heiti" />
          </th>
          <th>
            <download-csv :data="getExcelData" :name="getExcelFileName" delimiter=";" class="cursor-pointer float-right">
              <i class="fa fa-file-excel-o excelText"></i>
            </download-csv>
          </th>
        </tr>
      </thead>
      <tbody>
        <TableRowLoader v-if="loading" colspan="9" :center="true" />
        <TableRowEmpty v-if="!loading && this.list.length === 0" colspan="9" :center="true" />
        <tr
          v-for="item in getList"
          :key="item.teg_fjarvista"
          :class="{
            'active-table-row': selectedItem && selectedItem.teg_fjarvista === item.teg_fjarvista,
            'cursor-pointer': showSlidebar,
          }"
          @click="checkSlidebar(item)"
        >
          <td>{{ item.heiti }}</td>
          <td>{{ item.kodi }}</td>
          <td>{{ item.fjarvistar_margf }}</td>
          <td>{{ item.rod }}</td>
          <td><yes-no :item="item.virk"></yes-no></td>
          <td><yes-no :item="item.ma_kennari_skra"></yes-no></td>
          <td><yes-no :item="item.telst_sem_timi"></yes-no></td>
          <td>{{ item.samr_heiti }}</td>
          <td>
            <div class="float-right" v-if="canEdit">
              <b-btn variant="primary" class="mr-2 btn-xs" v-b-tooltip title="Breyta" @click.prevent="openSlidebar(item)">
                <i class="fa fa-pencil" />
              </b-btn>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <attendance-type-slidebar v-if="showSlidebar" :item="selectedItem" @closeSlidebar="closeSlidebar"> </attendance-type-slidebar>
  </div>
</template>

<script>
import types from '@/api/types';

import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

import CustomButton from '@/components/common/CustomButton.vue';
import YesNo from '@/components/common/YesNo.vue';

import TableRowLoader from '@/components/common/TableRowLoader.vue';
import TableRowEmpty from '@/components/common/TableRowEmpty.vue';
import LinkOrder from '@/components/common/LinkOrder.vue';

import AttendanceTypeSlidebar from '@/components/school/school/types/AttendanceTypeSlidebar.vue';

export default {
  name: 'absenceType',
  components: {
    TableRowLoader,
    TableRowEmpty,
    LinkOrder,
    AttendanceTypeSlidebar,
    CustomButton,
    YesNo,
  },
  computed: {
    getList() {
      return this.list.filter(
        x => this.search.name.length === 0 || (x.heiti && x.heiti.toUpperCase().startsWith(this.search.name.toUpperCase())),
      );
    },
    getExcelData() {
      const newList = [
        [],
        ['Tegundir fjarvista'],
        [],
        [
          'Tegund fjarvistar',
          'Kóði',
          'Fjarvistarmargfeldi',
          'Röð',
          'Virk',
          'Má kennari skrá',
          'Telst sem tími',
          'Samræmd tegund fjarvistar',
        ],
        ...this.getList.map(x => [
          x.heiti,
          x.kodi,
          x.fjarvistar_margf,
          x.rod,
          x.virk === 1 ? 'Já' : 'Nei',
          x.ma_kennari_skra === 1 ? 'Já' : 'Nei',
          x.telst_sem_timi === 1 ? 'Já' : 'Nei',
          x.samr_heiti,
        ]),
      ];
      return newList;
    },
    getExcelFileName() {
      return `tegund_fjarvista_${moment().format('YYYYMMDD')}_${moment().format('HHmm')}.csv`;
    },
    canEdit() {
      return this.loggedInUserHasWritePermission('skolahald_uppbygging');
    },
    ...mapGetters(['loggedInUserHasReadPermission', 'loggedInUserHasWritePermission']),
  },
  data() {
    return {
      loading: false,
      showSlidebar: false,
      selectedItem: {},
      search: {
        name: '',
      },
      list: [],
    };
  },
  methods: {
    async loadList() {
      try {
        this.loading = true;
        const response = await types.getAttendanceList();
        this.list = response.data.items;
        this.$nextTick(() => {
          if (this.$refs.focusInput) {
            this.$refs.focusInput.focus();
          }
        });
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading = false;
      }
    },
    openSlidebar(item) {
      this.selectedItem = item;
      this.showSlidebar = true;
    },
    closeSlidebar() {
      this.showSlidebar = false;
      this.selectedItem = {};
      this.loadList();
    },
    checkSlidebar(item) {
      if (this.showSlidebar) {
        this.openSlidebar(item);
      }
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
  created() {
    this.loadList();
  },
};
</script>
